export const environment = {
  production: false,
  baseUrl: 'https://demobackend.unimextech.com/',
};
